import React from 'react';
import { TrendingUpIcon } from 'lucide-react';
import { AnimatedMetric } from '../ui/AnimatedMetric';
export function ResultsSnapshot() {
  const results = [{
    headline: 'SCALABILITY UNLOCK',
    industry: 'Life Insurance',
    location: 'Multi-Market',
    interviews: 144,
    hires: 101,
    metric: {
      label: '70% Hire Rate',
      value: 70,
      suffix: '%'
    }
  }, {
    headline: 'REVENUE JUMP',
    industry: 'Windows',
    location: 'Western US',
    interviews: 388,
    hires: 250,
    metric: {
      label: 'New Revenue',
      value: 2,
      prefix: '$',
      suffix: 'M+'
    }
  }, {
    headline: 'ROOKIE RAMP-UP',
    industry: 'Roofing',
    location: 'Atlanta',
    interviews: 86,
    hires: 57,
    metric: {
      label: '66% Conversion',
      value: 66,
      suffix: '%'
    }
  }, {
    headline: 'RETENTION FIX',
    industry: 'Solar',
    location: 'Southwest',
    interviews: 215,
    hires: 142,
    metric: {
      label: '78% Retention',
      value: 78,
      suffix: '%'
    }
  }];
  return <section className="section-padding bg-gray-50" data-id="element-869">
      <div className="container-custom" data-id="element-870">
        <div className="max-w-3xl mx-auto text-center mb-12 md:mb-16" data-id="element-871">
          <div className="inline-flex items-center justify-center w-12 h-12 md:w-14 md:h-14 bg-amber/10 rounded mb-4 md:mb-6" data-id="element-872">
            <TrendingUpIcon className="h-6 w-6 md:h-7 md:w-7 text-amber" data-id="element-873" />
          </div>
          <h2 className="mb-4 md:mb-6" data-id="element-874">Math. Not Magic.</h2>
          <p className="text-base md:text-lg text-gray-600 leading-relaxed" data-id="element-875">
            Real companies. Real numbers. This is what happens when you install
            the HIRE Advantage.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-6 lg:gap-8 max-w-7xl mx-auto" data-id="element-876">
          {results.map((result, index) => <div key={index} className="bg-white rounded p-4 md:p-6 lg:p-8 shadow-lg border-2 border-gray-200 hover:border-amber transition-all" data-id="element-877">
              <div className="mb-4 md:mb-6" data-id="element-878">
                <div className="text-xs md:text-sm font-black text-amber uppercase tracking-wide mb-2 md:mb-3" data-id="element-879">
                  {result.headline}
                </div>
                <div className="inline-block bg-amber/10 text-amber px-2 py-0.5 md:px-3 md:py-1 rounded text-xs md:text-sm font-bold mb-2 md:mb-3" data-id="element-880">
                  {result.industry}
                </div>
                <p className="text-gray-600 text-xs md:text-sm" data-id="element-881">
                  {result.location}
                </p>
              </div>

              <div className="space-y-2 md:space-y-3 lg:space-y-4 mb-4 md:mb-6" data-id="element-882">
                <div className="flex justify-between items-center pb-2 md:pb-3 border-b border-gray-200" data-id="element-883">
                  <span className="text-gray-600 text-xs md:text-sm lg:text-base" data-id="element-884">
                    Interviews
                  </span>
                  <span className="text-lg md:text-xl lg:text-2xl font-bold text-navy" data-id="element-885">
                    {result.interviews}
                  </span>
                </div>
                <div className="flex justify-between items-center pb-2 md:pb-3 border-b border-gray-200" data-id="element-886">
                  <span className="text-gray-600 text-xs md:text-sm lg:text-base" data-id="element-887">
                    Hires
                  </span>
                  <span className="text-lg md:text-xl lg:text-2xl font-bold text-navy" data-id="element-888">
                    {result.hires}
                    {result.hires === 250 && '+'}
                  </span>
                </div>
              </div>

              <div className="bg-amber/5 rounded p-3 md:p-4 text-center border border-amber/20" data-id="element-889">
                <div className="text-xl md:text-2xl lg:text-3xl font-bold text-amber mb-1" data-id="element-890">
                  <AnimatedMetric value={result.metric.value} prefix={result.metric.prefix} suffix={result.metric.suffix} duration={1500} data-id="element-891" />
                </div>
                <p className="text-xs md:text-sm text-gray-600 font-medium" data-id="element-892">
                  {result.metric.label}
                </p>
              </div>
            </div>)}
        </div>

        <div className="mt-8 md:mt-12 text-center" data-id="element-893">
          <a href="/case-studies" className="inline-block text-amber font-semibold hover:text-amber-dark transition-colors text-sm md:text-base" data-id="element-894">
            See The Case Studies →
          </a>
        </div>
      </div>
    </section>;
}